import api from "@/api";
import { AxiosResponse } from "axios";
import OAuthToken from "@/types/OAuthToken";

async function getAccessToken(email: string, password: string): Promise<AxiosResponse<OAuthToken>> {
  return await api.post<OAuthToken>("/oauth/token", {
    username: email,
    password: password,
    client_id: import.meta.env.VITE_API_ID,
    client_secret: import.meta.env.VITE_API_SECRET,
    grant_type: "password",
  });
}

export default getAccessToken;
